import React from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { router } from "./routes";
import { MovieProvider } from "./context/movie-context";
import "./App.css";
import { AuthProvider } from "./AuthProvider";
import { RealtimeProvider } from "./hooks/usePlayerRealtime";
import { ModeProvider, useModeContext } from "./hooks/useMode";

const queryClient = new QueryClient();

const ThemedApp = () => {
  const { theme } = useModeContext();

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <RealtimeProvider>
            <MovieProvider>
              <RouterProvider router={router} />
            </MovieProvider>
          </RealtimeProvider>
        </AuthProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
};

function App() {
  return (
    <ModeProvider>
      <ThemedApp />
    </ModeProvider>
  );
}

export default App;
